import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const TotalAttendanceRedux = createActions({
  TotalAttendanceExcelRequest: [''],
  TotalAttendanceExcelSuccess: [''],
  TotalAttendanceExcelError: ['error'],
},
{
  prefix: 'TOTAL_ATTENDANCE_',
  defaultActions: {
    get: true,
  },
},
)

const { Types, Creators } = TotalAttendanceRedux
export const TotalAttendanceTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

const TotalAttendanceExcelRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const TotalAttendanceExcelSuccess = state => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
}, d)
const TotalAttendanceExcelError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

export const reducer = createReducer(INITIAL_STATE, {
  [Types.TotalAttendanceExcelRequest]: TotalAttendanceExcelRequest,
  [Types.TotalAttendanceExcelSuccess]: TotalAttendanceExcelSuccess,
  [Types.TotalAttendanceExcelError]: TotalAttendanceExcelError,
},
{
  defaultActions: {
    get: true,
  },
  Types,
},
)



// WEBPACK FOOTER //
// ./src/Data/Redux/TotalAttendanceRedux.js